import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import "./SideBar.css";
import { getSidebarItems, SidebarItem } from "./sidebar.config";

interface SideBarProps {
  collapse: boolean;
}

const SideBar = ({ collapse }: SideBarProps) => {
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const selectedClient = useSelector(
    (state: RootState) => state.selectedClient.selectedClient,
  );
  const applicationType = useSelector(
    (state: RootState) => state.applicationType.applicationType,
  );

  const items = getSidebarItems({
    roleId: user?.roleId,
    hasSelectedClient: Boolean(selectedClient),
    applicationType,
  });
  const topItems = items.filter((item) => item.placement === "top");
  const bottomItems = items.filter((item) => item.placement === "bottom");

  const renderMenuItem = ({ key, label, path, Icon, enabled }: SidebarItem) => {
    const content = (
      <>
        <Icon className="sidebar-menu-icon" aria-hidden="true" />
        <span className="sidebar-menu__label">{label}</span>
      </>
    );

    return (
      <li key={key}>
        {enabled ? (
          <NavLink
            to={path}
            end={path === "/"}
            aria-label={label}
            title={collapse ? label : undefined}
            className={({ isActive }) =>
              `sidebar-menu__link${
                isActive ? " sidebar-menu__link--active" : ""
              }`
            }
          >
            {content}
          </NavLink>
        ) : (
          <span
            className="sidebar-menu__link sidebar-menu__link--disabled"
            aria-disabled="true"
            title={label}
          >
            {content}
          </span>
        )}
      </li>
    );
  };

  return (
    <aside
      className={`sidebar ${
        collapse ? "sidebar--collapsed" : "sidebar--expanded"
      }`}
    >
      <div className="sidebar__header" aria-hidden="true" />

      <div className="sidebar__menus">
        <nav className="sidebar-menu" aria-label="Primary">
          <ul className="sidebar-menu__list">{topItems.map(renderMenuItem)}</ul>
        </nav>

        {bottomItems.length > 0 && (
          <nav
            className="sidebar-menu sidebar-menu--bottom"
            aria-label="Administration"
          >
            <ul className="sidebar-menu__list">
              {bottomItems.map(renderMenuItem)}
            </ul>
          </nav>
        )}
      </div>
    </aside>
  );
};

export default SideBar;
